import React from "react";
import DebouncedInput from "components/DebounceInput";
import useFeatureFlag from "hooks/useFeatureFlag";
import { useTranslation } from "react-i18next";
import { IconFileCertificate } from "@tabler/icons-react";
import clsx from "clsx";
import { searchStore } from "features/ProductSearch/SearchStore";
import { observer } from "mobx-react-lite";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";

export default observer(function (props: {
  onChange: (value: string | number) => void;
  value: string;
  open?: boolean;
  searchBarStyle?: string;
}) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { isFeatureVisible } = useFeatureFlag();
  const { t } = useTranslation();

  React.useEffect(() => {
    props?.open && inputRef.current?.focus();
  }, [props?.open]);

  const handleKeyPressed = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.code === "KeyA") {
      e.preventDefault();
      inputRef.current?.select();
    }
  };

  return (
    <div className="flex justify-between items-center pb-2">
      <DebouncedInput
        ref={inputRef}
        containerClassName={
          props.searchBarStyle
            ? props.searchBarStyle
            : "w-full mr-2 md:min-w-[700px]"
        }
        onChange={props.onChange}
        value={props.value}
        onKeyDown={handleKeyPressed}
      />
      {isFeatureVisible("epds_in_product_search") &&
        !COEStore.openedSearchInCE && (
          <div className="flex">
            <span className="px-2 text-gray-600">{t("commons.or")}</span>
            <div
              className={clsx(
                "whitespace-nowrap text-indigo-700 hover:text-indigo-500 text-base font-medium ml-2 cursor-pointer",
                "flex justify-between font-medium items-center"
              )}
              onClick={() => {
                searchStore.setOpenProductSearch({ state: false });
                searchStore.setOpenEPDSearch({
                  state: true,
                  term: props.value,
                });
              }}
            >
              <IconFileCertificate className="mr-2" />
              {t("productEditor.searchEPDGenerateProduct")}
            </div>
          </div>
        )}
    </div>
  );
});
